import { StyleSheet } from 'react-native';

import { Colors } from '@theme';
import { moderateScale } from '@utils/scaling';

export const styles = StyleSheet.create({
  contentContainer: {
    padding: moderateScale(20),
    backgroundColor: Colors.blackTwo,
  },
  header: {
    backgroundColor: Colors.blackTwo,
    paddingTop: moderateScale(20),
    paddingHorizontal: moderateScale(20),
  },
  border: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomColor: Colors.greyFour,
    paddingBottom: moderateScale(16),
  },
  filterGGQ: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
  filterCategory: {
    marginBottom: moderateScale(24),
  },
  filterItems: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: moderateScale(16),
  },
  controlItems: {
    justifyContent: 'space-between',
  },
  footer: {
    paddingTop: moderateScale(20),
    paddingHorizontal: moderateScale(20),
    paddingBottom: moderateScale(30),
    backgroundColor: Colors.greyFour,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  clearFilters: {
    paddingVertical: moderateScale(11),
    paddingHorizontal: moderateScale(21.5),
    borderRadius: moderateScale(12),
    backgroundColor: Colors.blackTwo,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: moderateScale(12),
  },
  filter: {
    flex: 1,
    borderRadius: moderateScale(12),
    paddingVertical: moderateScale(11),
    backgroundColor: Colors.purple,
    justifyContent: 'center',
    alignItems: 'center',
  },
  mood: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  moodText: {
    marginLeft: moderateScale(5),
  },
  moodIcon: {
    height: 24,
    width: 24,
    marginLeft: -5,
  },
});
